export function convertDate (mysqlDate) {
  var t
  var result = null
  if (typeof mysqlDate === 'string') {
    t = mysqlDate.split(/[- :]/)
    // when t[3], t[4] and t[5] are missing they defaults to zero
    result = new Date(t[0], t[1] - 1, t[2], t[3] || 0, t[4] || 0, t[5] || 0).getTime()
  }
  return result
}

export function dateDiffToNow (mysqlDate) {
  const now = Date.now()
  const date = convertDate(mysqlDate)
  const diffTime = date - now
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
  return diffDays
}



// WEBPACK FOOTER //
// ./src/util/date-convert.js